// extracted by mini-css-extract-plugin
export default {"parent_details":"parent-details_parent_details__M8gna","details":"parent-details_details__dVi3h","head_button":"parent-details_head_button__+EXBb"};